<template>
  <div class="noticiabackgroundcolor">
    <div class="extensao_banner">
      <BreadCrumb :breadcrumb="breadcrumb" class="bcp" />
      <h1>SASUMA / {{ $t("UMA_LANG_SASUMA_HOMEMENU_NOTICIAS") }}</h1>
    </div>
    <div class="row align-center marginTop">
      <div class="small-10 medium-10 large-10 columns" id="mainrow">
        <div class="row newsrow blockAnimate" id="mrow" data-equalizer="mrow">
          <SasNoticia
            :key="noticia.noticia_name"
            v-for="noticia in listItems" 
            :noticia="noticia"/>      
        </div>
        <pagination
          @changePage="getPage"
          @loadmore="loadmore"
          :showPagination="listItems.length > 0"
          :pages="pages"
          :currentPage="currentPage" />    
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import { ref, onMounted } from "vue";
import { i18n } from "@/main.js";
import { onBeforeRouteLeave } from 'vue-router';
import BreadCrumb from "@/components/BreadCrumb.vue";
import pagination from '@/components/pagination.vue';
import Searchbox from "@/components/searchbox.vue";
import SearchRow from "@/components/searchRow.vue";
import SasNoticia from "@/components/SasNoticia.vue";

export default {
  components: {
    BreadCrumb,
    pagination,
    Searchbox,
    SearchRow,
    SasNoticia
  },
  setup() {

    const { t } = i18n.global;
    const lang = i18n.global.locale;
    const lg = lang == "en" ? "/en" : "";

    //#region breadcrumb

    const breadcrumb = ref([]);
    onMounted(() => {
      breadcrumb.value = [
        { ID: 1, text: 'Homepage', href: `https://www.uma.pt${lg}` },
        { ID: 2, text: t("breadcrumb.sobre"), href: `https://www.uma.pt${lg}/sobre` },
        { ID: 3, text: t("breadcrumb.apoio"), href: `https://www.uma.pt${lg}/sobre/servico-apoio-estudantes` },
        { ID: 4, text: t("breadcrumb.sas"), route: { to: "/" } },
        { ID: 5, text: t("breadcrumb.noticias"), href: "#" }
      ];
    })
    

    var navigationbar = document.getElementsByClassName("title-bar")[0];
    navigationbar.classList.add("black");
    var offcontent = document.getElementsByClassName("off-canvas-content")[0];
    offcontent.classList.add("padding");

    onBeforeRouteLeave(async (to, from) => {
      var navigationbar = document.getElementsByClassName("title-bar")[0];
      navigationbar.classList.remove("black");
      var offcontent = document.getElementsByClassName("off-canvas-content")[0];
      offcontent.classList.remove("padding");
    });


    const currentPage = ref(1);
    const pages = ref(0);
    const totalElements = ref(0);
    const total = ref(0);

    const pageGenerator = () => {
      const generatePagesArray = (start, end) => Array.from(
        { length: end - start + 1 }, (_, i) => i + start
      );

      if (total.value < 8) {
        pages.value = generatePagesArray(1, total.value);
      } else {
        if (currentPage.value < 5) {
          pages.value = [...generatePagesArray(1, 5), '...', total.value];
        } else if (currentPage.value > total.value - 4) {
          pages.value = [1, '...', ...generatePagesArray(total.value - 4, total.value)];
        } else {
          pages.value = [1, '...', currentPage.value - 1, currentPage.value, currentPage.value + 1, '...', total.value];
        }
      }
    };

    const getPage = (page) => {
      window.scrollTo(0,0);
      currentPage.value = page;
      fetchDocuments();
    };

    const loadmore = () => {
      currentPage.value = currentPage.value + 1;
      fetchDocuments(true);
    };

    const listItems = ref([]);
    const limit = 9;

    const fetchDocuments = (shouldAdd = false) => {
      const of = (currentPage.value - 1) * limit;
      const url = `${import.meta.env.VITE_APP_AXIOS}/noticiassas?limit=${limit}&offset=${of}&publicado=1&idioma=${i18n.global.locale}&owner=${import.meta.env.VITE_APP_OWNER}&sort=noticia_data_publicacao`;
      axios.get(url).then(response => {
        const elements = response.data.data.map(el => {
          return {
              ...el,
              imagem: `${import.meta.env.VITE_APP_SITEURL}/wp-content/uploads/${el.noticia_imagem}`
          }
        });
        listItems.value = !shouldAdd ? elements : 
                        [...listItems.value, ...elements];
        totalElements.value = response.data.total;
        total.value = Math.ceil(response.data.total / limit);
        pageGenerator()
      }).catch(error => {
        console.log(error);
      })
    }

    fetchDocuments();

    return {
      breadcrumb,
      listItems,
      currentPage,
      getPage,
      loadmore,
      pages
    }
  }
}
</script>

<style lang="scss" scoped>
.extensao_banner h1 {
  text-align: center;
  font-family: "Montserrat Bold";
  font-size: 60px;
  color: #3f4244;
  padding-top: 105px;
  padding-bottom: 30px;
  transform: translate3D(0, -10px, 0);
}

.extensao_banner h1 {
  font-size: 55px;
  color: #4d5354;
}

.bcp {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
  padding-top: 15px;
  top: 110px;
}

@media (max-width: 1400px) {
  .extensao_banner h1 {
    font-size: 48px;
  }
}

@media (max-width: 1024px) {
  .extensao_banner h1 {
    font-size: 40px;
  }
}

@media (max-width: 767px) {
  .extensao_banner h1 {
    font-size: 25px !important;
    padding-top: 35px;
    padding-bottom: 0px;
  }
}

#mainrow{
  padding-right: 0rem;
  padding-left: 0rem;
  margin-bottom: 80px;
}
</style>